<template>
  <!-- TBA SKELETON LOADING -->
  <fixtures-row-skeleton v-if="status === 'loading'" />

  <template v-else-if="status === 'success'">
    <div
      data-test="fixtures-row"
      class="szw-row szw-w-full szw-h-19 szw-rounded-lg szw-bg-section-static szw-p-2 szw-gap-2"
      :class="{ 'szw-cursor-pointer': !disableCursor }"
      @click="emitOpenEvent"
    >
      <!-- DATE & STATUS SECTION -->
      <div class="szw-col__center szw-h-17 szw-w-17 szw-justify-center szw-flex-shrink-0">
        <span class="szw-text-xs">{{ formatDate() }}</span>
        <div class="szw-row szw-gap-1">
          <sprite v-if="props.row.live" sprite-id="live-indicator" color="#FF5F54" />
          <span class="szw-text-xxs szw-font-bold szw-uppercase szw-tracking-wider">{{ timeStatus }}</span>
        </div>
      </div>

      <!-- TEAMS & RESULT SECTION -->
      <div class="szw-col szw-gap-2 szw-w-full">
        <!-- TEAM -->
        <div class="szw-row szw-w-full szw-gap-2" v-for="team of props.row.teams" :key="team.id">
          <div class="szw-h-5 szw-w-5">
            <img v-if="team.logoUrl" class="szw-h-5 szw-w-5" :src="team.logoUrl" alt="team" />
            <fallback-logo v-else :text="team.shortName" />
          </div>

          <span
            :class="[
              'szw-text-xs szw-mr-auto szw-overflow-hidden szw-max-h-6 szw-whitespace-nowrap',
              { 'szw-font-bold': props.row.winnerId === team.id, 'szw-max-w-36': isSmallWidgetContainerSize }
            ]"
            style="text-overflow: ellipsis"
          >
            {{ localizeTeamName(team.id, team.name, langId) }}
          </span>

          <span :class="['szw-text-xs szw-w-7 szw-text-center', { 'szw-font-bold': props.row.winnerId === team.id }]">{{ team.score }}</span>
        </div>
      </div>
    </div>
  </template>
</template>

<script setup>
import FallbackLogo from '@/__core__/components/FallbackLogo.vue'
import Sprite from '@/__core__/components/sprite/Sprite.vue'
import FixturesRowSkeleton from './FixturesRowSkeleton.vue'
import { computed, inject } from 'vue'
import { localizeTeamName } from '@/__core__/localization/localization'

const props = defineProps({
  row: {
    type: Object,
    default: () => ({
      id: '',
      startTime: '',
      timeStatus: '',
      live: false,
      winnerId: '',
      teams: []
    })
  },
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  },
  disableCursor: {
    type: Boolean,
    default: false
  }
})

const status = inject('status')
const langId = inject('langId', '')

const emit = defineEmits(['open-event'])

const emitOpenEvent = () => {
  emit('open-event', props.row)
}

const formatDate = () => {
  const date = new Date(props.row.startTime)
  const day = date.getDate().toString().padStart(2, '0') // Ensure 2 digits
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // Months are 0-indexed
  const year = date.getFullYear().toString().slice(-2) // Get last 2 digits of the year

  return `${day}/${month}/${year}`
}

const formatTime = () => {
  const date = new Date(props.row.startTime)
  return date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false // Specify 24-hour time format
  })
}

const timeStatus = computed(() => {
  if (props.row.timeStatus !== '-') {
    return props.row.timeStatus
  }

  return formatTime()
})
</script>
